import React from 'react';
import PropTypes from 'prop-types';
import LoginBox from '../LoginBox/LoginBox';

function LoginBoxWrapper({ setIsLogin }) {
  return (
    <div className="card bg-light" style={{ minHeight: '4rem', maxWidth: '45rem' }}>
      <h5 className="card-header">Account Login</h5>
      <div className="card-body">
        <LoginBox setIsLogin={setIsLogin} />
      </div>
    </div>
  );
}

LoginBoxWrapper.propTypes = {
  setIsLogin: PropTypes.func.isRequired,
};

export default LoginBoxWrapper;
